 import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {FormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {BeachesService} from './beaches.service';
import {BeachAdvisoriesComponent} from './advisories/beach-advisories.component';
import {BeachDashboardComponent} from './dashboard/dashboard.component';
import {BeachOrganizationComponent} from './organization/beach-organization.component';
import {BeachResultsComponent} from './results/beach-results.component';
import {BeachStatusComponent} from './status/beach-status.component';
import {BeachSamplesComponent} from './samples/beach-samples.component';
 import {BeachesRoutingModule} from './beaches-routing.module';
import { BeachReportsComponent } from './reports/beach-reports.component';
import { ReportEmailModalComponent } from './report-email-modal/report-email-modal.component';
import { BeachSubmissionsListComponent } from './submission-list/submission-list.component';
import { SubmissionDetailComponent } from './submission-detail/submission-detail.component';
 import {SubmissionInlineComponent} from './submission-inline/submission-inline.component';
 // import {DisplayPipe} from 'shared';
 import {LookupModalComponent} from './lookup-modal/lookup-modal.component';
 import {DisplayFieldComponent} from '@shared/display-field/display-field.component';
 import {GenericInlineComponent} from '@shared/inlines/generic/generic.component';
 import {IsImagePipe} from '@shared/pipes/is-image.pipe';
 import {ToTrustedPipe} from '@shared/pipes/to-trusted.pipe';
 // import {SubmissionInlineComponent} from './submission-inline/submission-inline.component';

@NgModule({
  declarations: [
    // BeachStatusComponent,
    // BeachDashboardComponent,
    // BeachSamplesComponent,
    // BeachResultsComponent,
    // BeachAdvisoriesComponent,
    // BeachOrganizationComponent,
    // BeachReportsComponent,
    // // ReportEmailModalComponent\
    // BeachSubmissionsListComponent,
    SubmissionDetailComponent,
    SubmissionInlineComponent,
    // // DisplayPipe,
    // LookupModalComponent
    // // SubmissionInlineComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    DragDropModule,
    BeachesRoutingModule,
    DisplayFieldComponent,
    GenericInlineComponent,
    IsImagePipe,
    ToTrustedPipe,
    // SharedModule
  ],
  providers: [BeachesService]
})
export class BeachesModule {
}
